import { useSearchDateShortcut } from '@/hooks/useSearch'
import { secondToString } from '@/utils/date-format'
import type {
  CrudSearchItem,
  CrudSelectOption,
  CrudTableColumn
} from '@/types/crud-config'
import type { LiveOnlineStatisticsRecord } from './live-online-statistics.service'

interface LiveOnlineStatisticsSearchContext {
  channelOptions: CrudSelectOption[]
  departmentOptions: CrudSelectOption[]
  employeeOptions: CrudSelectOption[]
  optionsLoading: boolean
}

export function createLiveOnlineStatisticsSearchItems(
  context: LiveOnlineStatisticsSearchContext
): CrudSearchItem[] {
  return [
    {
      label: '直播间',
      prop: 'channelId',
      type: 'select',
      clearable: true,
      loading: context.optionsLoading,
      placeholder: '请选择直播间',
      options: context.channelOptions
    },
    {
      label: '客户昵称',
      prop: 'consumerNickName',
      type: 'input',
      clearable: true,
      placeholder: '请输入客户昵称'
    },
    {
      label: '观看时长',
      prop: 'duration',
      type: 'select',
      clearable: true,
      placeholder: '请选择观看时长',
      options: [
        { label: '≥ 5分钟', value: '300' },
        { label: '≥ 10分钟', value: '600' },
        { label: '≥ 20分钟', value: '1200' },
        { label: '≥ 25分钟', value: '1500' },
        { label: '≥ 30分钟', value: '1800' },
        { label: '≥ 40分钟', value: '2400' },
        { label: '≥ 50分钟', value: '3000' },
        { label: '≥ 60分钟', value: '3600' }
      ]
    },
    {
      label: '直播时间段',
      prop: 'accessTime',
      type: 'dateTimeRange',
      valueFormat: 'YYYY-MM-DD HH:mm:ss',
      shortcuts: useSearchDateShortcut(),
      startPlaceholder: '开始时间',
      endPlaceholder: '结束时间',
      disabledDate: (date) => date.getTime() > Date.now()
    },
    {
      label: '部门',
      prop: 'deptId',
      type: 'select',
      clearable: true,
      placeholder: '请选择部门',
      options: context.departmentOptions
    },
    {
      label: '员工',
      prop: 'empIds',
      type: 'select',
      clearable: true,
      loading: context.optionsLoading,
      placeholder: '请选择员工',
      options: context.employeeOptions
    }
  ]
}

export const liveOnlineStatisticsTableColumns: CrudTableColumn<LiveOnlineStatisticsRecord>[] =
  [
    {
      prop: 'consumerNickName',
      label: '客户昵称',
      slot: 'consumer',
      minWidth: 160,
      align: 'left',
      showOverflowTooltip: true
    },
    {
      prop: 'channelName',
      label: '直播间',
      minWidth: 120,
      showOverflowTooltip: true
    },
    {
      prop: 'deptName',
      label: '所属部门',
      minWidth: 100,
      showOverflowTooltip: true
    },
    {
      prop: 'empName',
      label: '所属员工',
      minWidth: 100,
      showOverflowTooltip: true
    },
    {
      prop: 'accessTime',
      label: '进入时间',
      minWidth: 160,
      showOverflowTooltip: true
    },
    {
      prop: 'endTime',
      label: '退出时间',
      minWidth: 160,
      showOverflowTooltip: true
    },
    {
      prop: 'newDuration',
      label: '观看时长',
      minWidth: 120,
      sortable: 'custom',
      formatter: (row) => secondToString(row.newDuration)
    }
  ]
